import { render, staticRenderFns } from "./AddColumnTable.vue?vue&type=template&id=3ae78f46&scoped=true"
import script from "./AddColumnTable.vue?vue&type=script&lang=js"
export * from "./AddColumnTable.vue?vue&type=script&lang=js"
import style0 from "./AddColumnTable.vue?vue&type=style&index=0&id=3ae78f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae78f46",
  null
  
)

export default component.exports